import React, { forwardRef, useImperativeHandle } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { fieldRequired, requiredInput } from '../../../core/formValidation';

type Props = {
  intl: any;
  initialValues?: any;
  onSubmit?: (values: any) => void;
  onValidityChange?: (valid: boolean) => void;
};

const EmployeeEditForm = forwardRef(function EmployeeEditForm(
  { intl, initialValues, onSubmit, onValidityChange }: Props,
  ref
) {
  const methods = useForm({ defaultValues: initialValues || {}, mode: 'onChange' });
  const { handleSubmit, formState } = methods;

  useImperativeHandle(ref, () => ({
    submit: () => handleSubmit((vals) => onSubmit && onSubmit(vals))(),
  }));

  React.useEffect(() => {
    if (onValidityChange) onValidityChange(formState.isValid);
  }, [formState.isValid, onValidityChange]);

  return (
    <FormProvider {...methods}>
      <div data-testid="edit-form">
        <div className="form-group">
          <label htmlFor="firstName">{intl.formatMessage({ id: 'firstName' })}</label>
          <Controller
            name="firstName"
            render={({ field }) =>
              requiredInput({
                input: field,
                id: 'firstName',
                type: 'text',
                className: 'form-control',
                placeholder: 'Enter team member first name',
              })
            }
            rules={{ required: true }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="lastName">{intl.formatMessage({ id: 'lastName' })}</label>
          <Controller
            name="lastName"
            render={({ field }) =>
              requiredInput({
                input: field,
                id: 'lastName',
                type: 'text',
                className: 'form-control',
                placeholder: 'Enter team member last name',
              })
            }
            rules={{ required: true }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">{intl.formatMessage({ id: 'email' })}</label>
          <Controller
            name="email"
            render={({ field }) =>
              requiredInput({
                input: field,
                id: 'email',
                type: 'email',
                className: 'form-control',
                placeholder: 'Enter team member email',
              })
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="phoneNumber">{intl.formatMessage({ id: 'phoneNumber' })}</label>
          <Controller
            name="phoneNumber"
            render={({ field }) =>
              requiredInput({
                input: field,
                id: 'phoneNumber',
                type: 'text',
                className: 'form-control',
                placeholder: 'Enter team member phone number (ex. XXX-XXX-XXXX)',
              })
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="position">{intl.formatMessage({ id: 'position' })}</label>
          <Controller
            name="position"
            render={({ field }) =>
              requiredInput({
                input: field,
                id: 'position',
                type: 'text',
                className: 'form-control',
                placeholder: 'Enter team member position',
              })
            }
          />
        </div>
      </div>
    </FormProvider>
  );
});

export default EmployeeEditForm;
